import { MutationTree } from 'vuex'
import { ProfileState } from './types'

export enum ProfileMutations {
  SET_DRAWER_STATE = 'SET_DRAWER_STATE'
}

export const mutations: MutationTree<ProfileState> = {
  [ProfileMutations.SET_DRAWER_STATE](state: ProfileState) {
    state.openDoctorDrawer = !state.openDoctorDrawer
  }
}
